import { SPACING_VALUES } from '@/utils';
import { useActiveProductSlice } from './useActiveProductSlice';
interface IUseSpacingBetweenProductCard {
  spacingClass: string | null;
  breakpoints: {};
  defaultSlidePerView: number | 'auto';
  defaultSpaciBetween: number;
  spacing_between_card: ISpaceType['spacing'];
  isProductCardLargImage: boolean;
}

interface ISpaceType {
  spacing: 'small' | 'medium' | 'large' | 'none';
}

const useSpacingBetweenProductCard = (): IUseSpacingBetweenProductCard => {
  const { spaceBetween, isLargeCard } = useActiveProductSlice();

  const spacing = spaceBetween as ISpaceType['spacing'];
  const isProductCardLarge = isLargeCard;

  const getClass = (spacing: ISpaceType['spacing']) =>
    `collections_${spacing ? spacing : 'none'}_spacing`;

  const selectedSpacing = SPACING_VALUES[spacing] || SPACING_VALUES.small;

  const getBreakpoints = () => {
    const breakpointsLargeCard = {
      1024: {
        slidesPerView: 4,
        spaceBetween: selectedSpacing.md,
      },
      1280: {
        slidesPerView: 5,
        spaceBetween: selectedSpacing.xl,
      },
      768: {
        slidesPerView: 'auto',
        spaceBetween: selectedSpacing.sm,
      },
      420: {
        slidesPerView: 'auto',
        spaceBetween: selectedSpacing.default,
      },
    };

    const breakpoints = {
      1024: {
        slidesPerView: 4,
        spaceBetween: selectedSpacing.md,
      },
      1280: {
        slidesPerView: 5,
        spaceBetween: selectedSpacing.xl,
      },
      1536: {
        slidesPerView: 6,
        spaceBetween: selectedSpacing.xl,
      },
      2048: {
        slidesPerView: 8,
        spaceBetween: selectedSpacing.xxl,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: selectedSpacing.default,
      },
      542: {
        slidesPerView: 3,
        spaceBetween: selectedSpacing.default,
      },
    };

    return isProductCardLarge ? breakpointsLargeCard : breakpoints;
  };

  const breakpoints = getBreakpoints();

  return {
    spacingClass: spacing !== 'none' ? getClass(spacing) : null,
    breakpoints: breakpoints,
    defaultSlidePerView: isProductCardLarge ? 'auto' : 2,
    defaultSpaciBetween: selectedSpacing.default,
    spacing_between_card: spacing,
    isProductCardLargImage: isProductCardLarge,
  };
};

export { useSpacingBetweenProductCard };
